import { render, staticRenderFns } from "./Salarios.vue?vue&type=template&id=1d746083&"
import script from "./Salarios.vue?vue&type=script&lang=js&"
export * from "./Salarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports